import React from 'react';

function AddButton({ title, onClick}) {
    return (
        <button onClick={onClick} className="bg-secondary-dark-bg px-4 text-[#fff] rounded-[10px] my-3">{  title  }</button>
    );
}

export default AddButton;